import Logo from './Logo';
import { InstagramIcon } from './icons';
import { APP_STORE_URL, INSTAGRAM_URL } from '../constants';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <a href="#top" aria-label="Peek home">
            <Logo />
          </a>
          <p className="footer__tagline">
            Movie &amp; TV recommendations from the people you trust.
          </p>
        </div>

        <nav className="footer__links" aria-label="Footer">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link"
          >
            App Store
          </a>
          <a href="#features" className="footer__link">
            Features
          </a>
          <a href="#peekster" className="footer__link">
            Peekster
          </a>
          <a href="#/privacy" className="footer__link">
            Privacy Policy
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link footer__link--icon"
            aria-label="Peek on Instagram"
          >
            <InstagramIcon />
            <span>Instagram</span>
          </a>
        </nav>
      </div>

      <div className="container footer__bottom">
        <p>&copy; {year} Peek. All rights reserved.</p>
      </div>
    </footer>
  );
}
